<template>
  <!-- 订单管理 -->
  <div class="guide-order">
    <!-- tab区 -->
    <el-tabs
      v-model="activeTabs"
      @tab-click="handleTabsClick"
    >
      <el-tab-pane
        label="订单"
        name="order"
      />
      <el-tab-pane
        label="商品订单"
        name="goodsOrder"
      />
    </el-tabs>

    <!-- 查询区 -->
    <div class="search-order">
      <div class="f-search-block search-top">
        <div class="search-items">
          <div class="field-item">
            <div class="field-item-label">
              订单号：
            </div>
            <div class="field-item-control">
              <el-input
                v-model="params.order_id"
                placeholder="请输入订单号"
                clearable
              />
            </div>
          </div>
          <div class="field-item">
            <div class="field-item-label">
              销售员工：
            </div>
            <div class="field-item-control">
              <el-input
                v-model="params.employee"
                placeholder="工号/姓名/手机号"
                clearable
              />
            </div>
          </div>
          <div class="field-item">
            <div class="field-item-label">
              绑定员工：
            </div>
            <div class="field-item-control">
              <el-input
                v-model="params.bind_employee"
                placeholder="工号/姓名/手机号"
                clearable
              />
            </div>
          </div>
          <div
            v-if="activeTabs === 'goodsOrder'"
            class="field-item"
          >
            <div class="field-item-label">
              商品：
            </div>
            <div class="field-item-control">
              <!-- <el-input
                v-model="params.bind_employee"
                placeholder="商品名称/商品货号"
                clearable
              /> -->
              <el-input
                v-model="keyword"
                class="name-mobile-input"
                placeholder="请输入内容"
              >
                <el-select
                  slot="prepend"
                  v-model="keywordType"
                  style="width: 120px"
                  placeholder="请选择"
                  size="small"
                >
                  <el-option
                    v-for="(item, index) in keyWordMap"
                    :key="index"
                    :label="item"
                    :value="index"
                  />
                </el-select>
              </el-input>
            </div>
          </div>
          <div>
            <el-button
              type="primary"
              @click="haddleSearch"
            >
              查询
            </el-button>
          </div>
        </div>
      </div>

      <div class="f-search-block">
        <div class="search-items">
          <div class="field-item">
            <div class="field-item-label">
              订单状态：
            </div>
            <div class="field-item-control">
              <el-select
                v-model="params.order_status"
                class="select"
                multiple
                placeholder="请选择"
                @change="statusChange"
              >
                <el-option
                  v-for="(item, index) in statusList"
                  :key="index"
                  :label="item.label"
                  :value="item.name"
                />
              </el-select>
            </div>
          </div>
          <div class="field-item">
            <div class="field-item-label">
              门店：
            </div>
            <div class="field-item-control">
              <el-input
                v-model="storeNum"
                placeholder="全部门店"
                style="width: 240px"
              >
                <div slot="append">
                  <el-link
                    type="primary"
                    style="margin-right: 10px"
                    @click="storeVisible = true"
                  >
                    编辑
                  </el-link>
                  <el-link
                    type="primary"
                    @click="clearStore"
                  >
                    重置
                  </el-link>
                </div>
              </el-input>
            </div>
          </div>
          <div class="field-item">
            <div class="field-item-label">
              创建时间：
            </div>
            <div class="field-item-control">
              <el-date-picker
                v-model="dateValue"
                :style="{ width: '360px' }"
                type="daterange"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerDateOptions"
                @change="dateChange"
              />
            </div>
          </div>
          <div>
            <el-button
              type="primary"
              class="m-r-6 export-btn"
              plain
              @click="exportVisible = true"
            >
              导出{{ activeTabs === 'goodsOrder' ? '子' : '' }}订单
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 表格数据 -->
    <div class="f-table-block">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane
          v-for="item in tabList"
          :key="item.name"
          :label="item.label"
          :name="item.name"
        />

        <template v-if="activeTabs === 'order'">
          <OrderTable
            :list-data="list"
            :loading="loading"
          />
        </template>
        <template v-else>
          <GoodsTable
            :list-data="list"
            :loading="loading"
          />
        </template>

        <el-pagination
          class="table-pagination"
          background
          :current-page="params.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="params.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total_count"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </el-tabs>
    </div>

    <!-- 订单导出 -->
    <SpExportList
      v-model="exportVisible"
      show-employee-status
      :files-type="filesType"
      show-order-status
      include-current-date
      title="订单导出"
    >
      订单导出说明：<br>
      导出订单成功后，请去设置 > 文件导出列表 下载已经生成的报表
    </SpExportList>

    <!-- 编辑门店 -->
    <SpStoreSelect
      v-model="storeVisible"
      :select-data="selectStoreData"
      @chooseStore="chooseStore"
    />
  </div>
</template>
<script>
import OrderTable from './comps/orderTable.vue'
import GoodsTable from './comps/goodsTable.vue'

export default {
  name: 'Salesman',
  components: {
    OrderTable,
    GoodsTable
  },

  data () {
    const keyWordMap = {
      'item_name': '商品名称',
      'item_bn': '商品货号'
    }
    return {
      keyWordMap,
      keywordType: 'item_name',
      keyword: '',
      activeTabs: 'order',
      pickerDateOptions: {
        disabledDate (date) {
          return date.getTime() > new Date()
        }
      },
      tabList: [
        { name: '0', label: '全部' },
        { name: '1', label: '员工' },
        { name: '2', label: '编外' }
      ],
      statusList: [
        { name: 'notpay', label: '待付款' },
        { name: 'refundsuccess', label: '已取消' },
        { name: 'notship', label: '待发货' },
        { name: 'shipping', label: '待收货' },
        { name: 'finish', label: '已完成' },
        { name: 'ziti', label: '待核销' }
      ],
      activeName: '0', //选中的tab
      list: [], //列表数据
      loading: false, //表格的加载
      params: {
        page: 1,
        page_size: 20,
        order_id: '',
        employee: '',
        bind_employee: '',
        employee_status: '0',
        order_status: [],
        store_bn: [],
        start_date: '',
        end_date: ''
      },
      total_count: 0, //总数据量

      // 选择店铺
      storeVisible: false, //选择门店
      selectStoreData: [], //主任务门店列表
      storeIds: -1, //选择门店的id,
      storeNum: '',

      exportVisible: false,
      dateValue: [],
      filesType: 7 // 7 订单列表导出; 14 商品订单导出
    }
  },
  computed: {},
  mounted () {
    this.getList()
  },
  methods: {
    handleTabsClick (tab) {
      this.activeTabs = tab.name
      this.params = {
        page: 1,
        page_size: 20,
        order_id: '',
        employee: '',
        bind_employee: '',
        employee_status: '0',
        order_status: [],
        store_bn: [],
        start_date: '',
        end_date: ''
      }
      this.selectStoreData = []
      this.storeIds = []
      this.storeNum = ''
      this.dateValue = []
      this.keywordType = 'item_name'
      this.keyword = ''
      this.activeName = '0' //选中的tab
      this.filesType = tab.name === 'order' ? 7 : 14
      this.getList()
    },
    // 获取导购列表
    async getList () {
      this.loading = true
      const params = { ...this.params }
      let data = null
      if (this.activeTabs === 'order') {
        data = await this.$api.order.getOrderList(params)
      } else if (this.activeTabs === 'goodsOrder') {
        const { keywordType, keyword } = this
        params[keywordType] = keyword
        data = await this.$api.order.getGoodsOrderList(params)
      }

      if (data) {
        this.list = data.list
        this.total_count = Number(data.total_count)
        this.loading = false
      }
    },

    // 选择门店
    chooseStore (selectdata, storeids) {
      this.selectStoreData = selectdata
      this.storeIds = storeids
      let storeBns = []
      selectdata.forEach((v) => {
        storeBns = storeBns.concat(v.store_bn)
      })
      this.params.store_bn = storeBns
      this.storeNum = '已选择' + selectdata.length + '家门店'
      this.storeVisible = false
      this.haddleSearch()
    },

    //重置门店选择
    clearStore () {
      this.selectStoreData = []
      this.storeIds = []
      this.storeNum = ''
      this.params.store_bn = []
      this.haddleSearch()
    },

    // 导购列表点击切换tab
    handleClick () {
      this.params.employee_status = this.activeName
      this.params.page = 1
      this.getList()
    },

    // 导购列表分页
    handleSizeChange (val) {
      this.params.page = 1
      this.params.page_size = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getList()
    },

    // 导购列表数据查询
    haddleSearch () {
      this.params.page = 1
      this.getList()
    },

    // 订单状态动态查询
    statusChange (value) {
      console.log(value, '订单状态')
      let arr = JSON.parse(JSON.stringify(value))
      this.params.order_status = arr
      this.haddleSearch()
    },

    // 日期查询
    dateChange (value) {
      console.log(value, 'valuevaluevalue')
      this.dateValue = value
      this.params.start_date = value ? value[0] || '' : ''
      this.params.end_date = value ? value[1] || '' : ''
      this.haddleSearch()
    }
  }
}
</script>
<style lang="scss" scoped>
.guide-order {
  .search-order {
    .search-top {
      border-bottom-color: #fff;
    }
  }
}
.upload-preview {
  text-align: center;
  max-width: 200px;
  border: 1px solid #ddd;
  padding: 10px;
  position: relative;
  img {
    max-width: 200px;
    margin: 0 auto;
  }
}
.text-ellipsis {
  display: inline-block;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.bind-store {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.store-select-item {
  display: flex;
  align-items: center;
}
.operation {
  margin-bottom: 20px;
}
.export-btn {
  margin-bottom: 10px;
}
</style>
